import { Fragment } from "react";
import Markdown from "markdown-to-jsx";

import { escapeMarkdown, transformMarkdown } from "@utils/ai-context.util";
import { RelatedEntity } from "@app-types/related-items.type";
import { CitationComponent } from "./CitationComponent";
import { AnchorComponent } from "./AnchorComponent";
import { cn } from "@utils/tailwind.util";

interface IMarkdownContentProps {
  text: string;
  sources: Record<number, RelatedEntity>;
  disableMarkdown?: boolean;
  order: Record<string, number>;
}

export function MarkdownContent({ text, sources, disableMarkdown, order }: IMarkdownContentProps) {
  return (
    <Markdown
      options={{
        wrapper: Fragment,
        overrides: {
          Citation: {
            component: (props) => <CitationComponent {...props} sources={sources} order={order} />,
          },
          a: {
            component: (props) => <AnchorComponent {...props} />,
          },
          p: {
            component: ({ children, ...props }) => (
              <p {...{ ...props, className: cn("cursor-text select-text", props.className) }}>
                {children}
              </p>
            ),
          },
          span: {
            component: ({ children, ...props }) => (
              <p {...{ ...props, className: cn("cursor-text select-text", props.className) }}>
                {children}
              </p>
            ),
          },
        },
      }}
      children={
        disableMarkdown
          ? escapeMarkdown(transformMarkdown({ text, disableCitations: true }))
          : transformMarkdown({ text })
      }
    />
  );
}
